module.exports = __webpack_public_path__ + "b309ea48d594dcc6f6e5d9bb3077eecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/Device.png
// module id = 813
// module chunks = 0